import { AppError } from "./AppError";

//

export class MongooseError extends AppError {
  constructor(message: string) {
    super(message, {
      isOperational: false,
      statusCode: 500,
    });
    this.name = "MongooseError";
    Error.captureStackTrace(this, MongooseError);
  }
}

//

export class MongooseDuplicateKeyError extends MongooseError {
  constructor(message: string) {
    super(message);
    this.name = "MongooseDuplicateKeyError";
    Error.captureStackTrace(this, MongooseDuplicateKeyError);
  }

  static isDuplicateKeyError(error: unknown): error is Error & { code: 11000 } {
    return (
      typeof error === "object" &&
      error !== null &&
      "code" in error &&
      typeof error.code === "number" &&
      error.code === 11000
    );
  }

  static throwOnDublicateError(error: unknown, message?: string) {
    if (MongooseDuplicateKeyError.isDuplicateKeyError(error)) {
      throw new MongooseDuplicateKeyError(message ?? error.message);
    }
  }
}
